import React, {Component, PropTypes} from 'react'
import Cannonicalize from '../Cannonicalize'
import ClientSideCacheController from '../ClientSideCacheController'
import ZipInput from '../ZipInput'
const radioAffiliates = ['khtt','kbez','kvoo','kfaq','kxbl']
class WeatherBlock extends Component {
  constructor(props) { // gives us acces to props, fires long before page load
    super(props) // assigns props to this.props
    //all the import links are set from the config file
    this.affiliate = props.affiliate;
    this.isRadio = radioAffiliates.some(rA => rA === this.affiliate)
    this.state = {
    }
  }

  componentWillMount() {
    try {
      this.setState(Cannonicalize.forecast(this.props.FRN_rawResponses[0].data))
    } catch (e) {
      console.log('Weather Page got bad forecast data from FRN_ in WeatherBlock', e)
    }
    console.log('Weather Block as ' +this.props.affiliate.toUpperCase())
    if(typeof window !== 'object')
      return

    ClientSideCacheController.setAffiliate(this.props.affiliate)
    ClientSideCacheController.get('forecast').then((data)=>{
      this.setState(data)
    })
  }



  render() { // REQUIRED
    if(!this.state.forecasts || !this.state.forecasts.length)
      return null
    return (
      <div className='gnm-weather-block visible-xs-block row' >
        <div className='col-xs-12 no-side-pad'>
          <h5 className='title'>Current Weather</h5>
          <div className='zip'>
            <ZipInput>
              <a href='#'>{this.state.city}, {this.state.state}<span className="glyphicon glyphicon-map-marker"></span></a>
            </ZipInput>
          </div>
         <div className='relative'>
          <img src={this.props.meteorologistImage} className='background'/>
          <img src={this.props.logoUrl} className="logo" />
          <div className='forecast'  >
            <img src={this.state.conditionIcon} className='icon'/>
            <h3  className='temperature heavy'>{this.state.temp}<sup>&deg;</sup></h3>
            <div className='smallest-font grey heavy '>Feels Like <span className=' white heavy medium-font'>{this.state.feelsLike}<sup>&deg;</sup></span></div>
            <div className='white heavy medium-font'>{this.state.conditionText}</div>
            <div>
              <span className='grey smallest-font'>High / Low  </span>
              <span className='heavy medium-font white'>{this.state.forecasts[0].high }<sup>&deg;</sup></span>
              <span className='grey medium-font'> / { this.state.forecasts[0].low}<sup>&deg;</sup></span>
            </div>
            <div>
              <span className='grey smallest-font'>Wind</span>
              <span className='white medium-font heavy'> {this.state.windDirection} / {this.state.windSpeed}mph</span>
            </div>
            <div className='attribution'>
              <div className='smallest-font white'>CHIEF METEOROLOGIST</div>
              <div className='white largest-font tight all-caps'>
                <span className='heavy'>{this.props.meteorologistFirstName}</span>
                <span> {this.props.meteorologistLastName}</span>
              </div>
            </div>
          </div>
         </div>
         {this.state.forecasts.slice(0,3).map((f,i,a)=>{
           return(
             <a className='one-third' href={this.isRadio ? 'https://www.newson6.com/weather' : '/weather'} key={i}>
               <div className='heavy all-caps white largest-font'>{f.date.substring(0,3)}</div>
               <img src={f.conditionicon} />
               <div className='heavy white largest-font'>
                 <span >{f.high}<sup>&deg;</sup></span><span className='grey'>/ {f.low}<sup>&deg;</sup></span>
               </div>
             </a>
           )
         })}
         <div className='half left'>
           <a className ='white heavy smallest-font' href={this.isRadio ? 'https://www.newson6.com/weather' :'/weather'}>View Full Forecast</a>
         </div>
         <div className='half right'>
           <a className='white heavy smallest-font' href={this.isRadio ? "https://www.newson6.com/national-radar" : "/national-radar"} >View Radar Map</a>
         </div>
        </div>
      </div>
    )
  }
}

export default WeatherBlock



// WEBPACK FOOTER //
// ./app/components/custom/ssr/WeatherBlock/index.js